import { useCallback, useState, } from 'react';
export const useSinglePickerField = (value) => {
    const [localValue, setLocalValue,] = (useState(value));
    const onChange = (useCallback((event) => {
        const { value: targetValue, } = (event
            .target);
        setLocalValue(targetValue);
    }, []));
    return {
        onChange,
        value: localValue,
    };
};
